import { IsInt, Min } from 'class-validator';

export class ReviseSectionDto {
  @IsInt()
  @Min(1)
  version!: number;
}
